import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/candidate_graduate_roles.json";

export const useCandidateGraduateRoles = () => useSourceFlowCollection(data);

export default useCandidateGraduateRoles;
